import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DataContext from "../../context/data-context";
import SidebarButton from "../UI/SidebarButton";
import { AuthContext } from "../../context/auth-context";
import { FaUserCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const { partner } = useContext(DataContext);
  const selected = location.pathname.slice(1).split("/")[0] || "general";

  return (
    <div className="hidden w-full container md:block md:min-h-[90vh]">
      <div className="flex flex-col items-center space-y-2">
        <div className="w-16 h-16">
          {partner?.photoURL ? (
            <img src={partner.photoURL} className="w-16 h-16 rounded-full contain" />
          ) : (
            <FaUserCircle className="w-full h-full text-yellow-600 cursor-pointer" />
          )}
        </div>
        <p className="text-center text-stone-300">
          {partner?.name || user.displayName}
        </p>
      </div>
      <div className="grid gap-8 mt-16 mb-12">
        <SidebarButton
          title="General"
          selected={selected}
          onClick={() => navigate("/general")}
        />
        <SidebarButton
          title="Vehicles"
          selected={selected}
          onClick={() => navigate("/vehicles")}
        />
        <SidebarButton
          title="Payments"
          selected={selected}
          onClick={() => navigate("/payments")}
        />
        <SidebarButton
          title="Settings"
          selected={selected}
          onClick={() => navigate("/settings")}
        />
      </div>
    </div>
  );
}
